module.exports = __webpack_public_path__ + "img/文留镇.f13f6f8e.png";